export enum SpinnerSize {
  SMALL, DEFAULT
}
